import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class MoveOutReasonService {
  getAll(organizationId: string, propertyId: string) {
    const requestOptions = {
      method: 'GET',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(
      `${apiURL}/${organizationId}/${propertyId}/lease-move-out-reasons`,
      requestOptions,
    );
  }
}

export default MoveOutReasonService;
